import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Button from './Button';

interface ErrorStateProps {
  error: Error | string;
  onRetry?: () => void;
  title?: string;
}

export default function ErrorState({ 
  error, 
  onRetry, 
  title = 'Something went wrong' 
}: ErrorStateProps) {
  const errorMessage = error instanceof Error ? error.message : error;

  return (
    <div className="text-center py-12 px-4">
      <ExclamationTriangleIcon className="h-12 w-12 text-error mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-600 mb-4 max-w-md mx-auto">{errorMessage}</p>
      {onRetry && (
        <Button onClick={onRetry} variant="primary">
          Try Again
        </Button>
      )}
    </div>
  );
}

